import axios from 'axios';

// 1. Fetching token
export interface FetchTokenResponse {
  token_type: string;
  expires_in: number;
  access_token: string;
  scope: string;
}
export async function fetchToken(): Promise<FetchTokenResponse> {
  try {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept-Encoding': 'gzip, deflate, br',
    };

    const clientId = '';
    const secretKey = '';
    const grantType = '';
    const id = '';

    let url = `https://metroplusportal.okta.com/oauth2/${id}/v1/token?client_id=${clientId}&client_secret=${secretKey}&grant_type=${grantType}`;

    const response = await axios({
      url,
      method: 'post',
      headers: headers,
      maxRedirects: 15,
    });

    if (response.status < 200 || response.status >= 300) {
      return Promise.reject(response.statusText);
    }

    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
}

// 2. Providers Query
export interface FetchProvidersResponse {
  success: boolean;
  data: FetchProvidersDataResponse;
  time: number;
  errorMessage: string;
}

export interface FetchProvidersDataResponse {
  Facets: Facets;
  Results: ProviderItem[];
  Count: number;
  state: string;
  page: number;
}

export interface Facets {
  BoroughName: BoroughName[];
  Specialty: Specialty[];
  Gender: Gender[];
}

export interface BoroughName {
  Type: number;
  From: any;
  To: any;
  Value: string;
  Count: number;
}

export interface Specialty {
  Type: number;
  From: any;
  To: any;
  Value: string;
  Count: number;
}

export interface Gender {
  Type: number;
  From: any;
  To: any;
  Value: string;
  Count: number;
}

export interface ProviderItem {
  Document: Provider;
  Score: number;
  Highlights: any;
}

export interface Provider {
  Record_ID: string;
  ProvOrg?: null | string;
  LastName: string;
  FirstName: string;
  Degree: string;
  PRID: string;
  BoardStatus: any;
  Gender: string;
  SpecialtyType: string;
  Specialty: string;
  OfficeName: string;
  Address1: string;
  Address2?: null | string;
  City: string;
  State: string;
  ZIP: string;
  BoroughName: string;
  Phone: string;
  HHC_Flag: string;
  Limitations_Additions?: null | string;
  Languages?: null | string;
  PanelStatus: string;
  Provnum: any;
  FaciltyType: string;
  EveningHours_Indicator: string;
  Latitude: string;
  Longitude: string;
  HospName1: any;
  NPI: string;
  MMIS: any;
  HandicapAccessible_Indicator: string;
  Note1: string;
  Note2: any;
  Note3: number;
  NetworkType_Indicator: string;
  GeoLocation: GeoLocation;
  Address_K: any;
  provider_location_id: any;
  default_visit_reason_id: any;
  ZocIndicator: number;
  Notes2: string;
}

export interface GeoLocation {
  Latitude: number;
  Longitude: number;
  IsEmpty: boolean;
  Z: any;
  M: any;
  CoordinateSystem: CoordinateSystem;
}

export interface CoordinateSystem {
  EpsgId: number;
  Id: string;
  Name: string;
}
export interface FetchProvidersParams {
  token?: string;
  query?: string;
  state?: string;
  page?: number;
}

export async function fetchProviders(params: FetchProvidersParams): Promise<FetchProvidersResponse> {
  try {
    // Using backend of WP site as a proxy
    const url = `${window.location.hostname === 'localhost' ? 'http://127.0.0.1' : ''}/wp-json/ai-search-providers/v1/providers`;
    const headers = {
      'Content-Type': 'application/json',
    };

    const rawQuery = JSON.stringify(params);

    const response = await axios({
      url,
      method: 'post',
      headers: headers,
      data: rawQuery,
    });

    if (response.status < 200 || response.status >= 300) {
      return Promise.reject(response.statusText);
    }

    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
}
